import React, { createContext, useContext, useState, useCallback } from 'react';
import dayjs from 'dayjs';

const CalendarContext = createContext();

export const useCalendar = () => {
  const context = useContext(CalendarContext);
  if (!context) {
    throw new Error('useCalendar must be used within a CalendarProvider');
  }
  return context;
};

export const CalendarProvider = ({ children }) => {
  const [selectedMonth, setSelectedMonth] = useState(dayjs());
  const [isTransitioning] = useState(false);

  const updateSelectedMonth = useCallback((newMonth) => {
    setSelectedMonth(newMonth);
  }, []);

  const value = {
    selectedMonth,
    updateSelectedMonth,
    isTransitioning,
    pendingMonth: null
  };

  return (
    <CalendarContext.Provider value={value}>
      {children}
    </CalendarContext.Provider>
  );
};

export default CalendarContext;